/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AttendanceTypeEnum,
  AttendanceTypeEnumOptional,
  AttendanceTypeEnumMetaI,
  AttendanceTypeEnumTrackedI,
} from "./attendance-type-enum";
import {
  AttendanceTypeEnumTracked,
  AttendanceTypeEnumMeta,
} from "./attendance-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassAttendanceBase,
  UnifiedClassAttendanceBaseOptional,
  UnifiedClassAttendanceBaseMetaI,
  UnifiedClassAttendanceBaseTrackedI,
} from "./unified-class-attendance-base";
import {
  UnifiedClassAttendanceBaseTracked,
  UnifiedClassAttendanceBaseMeta,
} from "./unified-class-attendance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassAttendanceRef,
  UnifiedClassAttendanceRefOptional,
  UnifiedClassAttendanceRefMetaI,
  UnifiedClassAttendanceRefTrackedI,
} from "./unified-class-attendance-ref";
import {
  UnifiedClassAttendanceRefTracked,
  UnifiedClassAttendanceRefMeta,
} from "./unified-class-attendance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionRef,
  UnifiedClassSessionRefOptional,
  UnifiedClassSessionRefMetaI,
  UnifiedClassSessionRefTrackedI,
} from "./unified-class-session-ref";
import {
  UnifiedClassSessionRefTracked,
  UnifiedClassSessionRefMeta,
} from "./unified-class-session-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";

/**
 *
 * @export
 * @interface UnifiedClassAttendanceFull
 */
export interface UnifiedClassAttendanceFullOptional extends UnifiedClassAttendanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassAttendanceFull
   */
  assignId?: number;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceFull
   */
  attend?: AttendanceTypeEnum;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof UnifiedClassAttendanceFull
   */
  sessionId?: UnifiedClassSessionRefOptional;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassAttendanceFull
   */
  signupId?: UnifiedClassSignupRefOptional;
}

export interface UnifiedClassAttendanceFull
  extends
    UnifiedClassAttendanceFullOptional,
    UnifiedClassAttendanceBase,
    UnifiedClassAttendanceRef {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassAttendanceFull
   */
  assignId: number;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceFull
   */
  attend?: AttendanceTypeEnum;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof UnifiedClassAttendanceFull
   */
  sessionId: UnifiedClassSessionRef;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassAttendanceFull
   */
  signupId: UnifiedClassSignupRef;
}

export interface UnifiedClassAttendanceFullTrackedI extends UnifiedClassAttendanceBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassAttendanceFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceFull
   */
  attend?: AttendanceTypeEnum;
  attendIsSet: boolean;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof UnifiedClassAttendanceFull
   */
  sessionId?: UnifiedClassSessionRefTrackedI;
  sessionIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassAttendanceFull
   */
  signupId?: UnifiedClassSignupRefTrackedI;
  signupIdIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassAttendanceFull",
  function (model: UnifiedClassAttendanceFull) {
    const transformDatessessionId = transformDatesMap.get(
      "UnifiedClassSessionRef",
    );
    if (transformDatessessionId && model.sessionId) {
      transformDatessessionId(model.sessionId);
    }
    const transformDatessignupId = transformDatesMap.get(
      "UnifiedClassSignupRef",
    );
    if (transformDatessignupId && model.signupId) {
      transformDatessignupId(model.signupId);
    }
  },
);

export type UnifiedClassAttendanceFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  attend: PropertyMeta<AttendanceTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  sessionId: PropertyMeta<UnifiedClassSessionRefMetaI>;
  //isDate: false
  //isDatetime: false
  signupId: PropertyMeta<UnifiedClassSignupRefMetaI>;
}>;

export var UnifiedClassAttendanceFullMeta: UnifiedClassAttendanceFullMetaI =
  {} as UnifiedClassAttendanceFullMetaI;
UnifiedClassAttendanceFullMeta = typeMeta("UnifiedClassAttendanceFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  attend: propertyMeta("attend", false, false, false, AttendanceTypeEnumMeta),
  sessionId: propertyMeta(
    "sessionId",
    false,
    true,
    false,
    UnifiedClassSessionRefMeta,
  ),
  signupId: propertyMeta(
    "signupId",
    false,
    true,
    false,
    UnifiedClassSignupRefMeta,
  ),
});

const metaI = UnifiedClassAttendanceFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassAttendanceRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassAttendanceRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassAttendanceBaseMeta]);
  metaI.attend.inheritedFrom = UnifiedClassAttendanceBaseMeta.attend;
});

export class UnifiedClassAttendanceFullTracked
  extends UnifiedClassAttendanceBaseTracked
  implements UnifiedClassAttendanceFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  attend__I?: AttendanceTypeEnum = undefined;
  attendIsSet: boolean = false;
  set attend(v: undefined | AttendanceTypeEnum) {
    if (v !== undefined) {
      this.attend__I = v;
      this.attendIsSet = true;
    } else {
      this.attend__I = v || undefined;
      this.attendIsSet = false;
    }
    this.changeTracker = true;
  }
  get attend() {
    return this.attend__I;
  }
  sessionId__I?: UnifiedClassSessionRefTracked = undefined;
  sessionIdIsSet: boolean = false;
  set sessionId(v: undefined | UnifiedClassSessionRefTracked) {
    if (v !== undefined) {
      this.sessionId__I = v;
      this.sessionIdIsSet = true;
    } else {
      this.sessionId__I = v || undefined;
      this.sessionIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get sessionId() {
    return this.sessionId__I;
  }
  signupId__I?: UnifiedClassSignupRefTracked = undefined;
  signupIdIsSet: boolean = false;
  set signupId(v: undefined | UnifiedClassSignupRefTracked) {
    if (v !== undefined) {
      this.signupId__I = v;
      this.signupIdIsSet = true;
    } else {
      this.signupId__I = v || undefined;
      this.signupIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get signupId() {
    return this.signupId__I;
  }
  constructor(
    config?: UnifiedClassAttendanceFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.sessionId?.setIds();

    this.signupId?.setIds();
  }
  assignFrom(
    config: UnifiedClassAttendanceFullOptional,
    options?: AssignOptions,
  ): UnifiedClassAttendanceFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.attend && this.attendApplyFilter(optionsRequired.filter)) {
      this.attend = config.attend;
      if (optionsRequired.unassign) this.attendIsSet = false;
      else this.attendIsSet = true;
    }
    if (config.sessionId && this.sessionIdApplyFilter(optionsRequired.filter)) {
      this.sessionId = new UnifiedClassSessionRefTracked(
        config.sessionId,
        options,
      );
      if (optionsRequired.unassign) this.sessionIdIsSet = false;
      else this.sessionIdIsSet = true;
    }
    if (config.signupId && this.signupIdApplyFilter(optionsRequired.filter)) {
      this.signupId = new UnifiedClassSignupRefTracked(
        config.signupId,
        options,
      );
      if (optionsRequired.unassign) this.signupIdIsSet = false;
      else this.signupIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassAttendanceFullTrackedI {
    const cloned = {} as UnifiedClassAttendanceFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.attendIsSetDeep() &&
      this.attendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendIsSet = true;
      cloned.attend = this.attend;
    } else {
      //cloned.attendIsSet = false
    }
    if (
      this.sessionIdIsSetDeep() &&
      this.sessionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionIdIsSet = true;
      cloned.sessionId = this.sessionId?.removeUnset(filter);
    } else {
      //cloned.sessionIdIsSet = false
    }
    if (
      this.signupIdIsSetDeep() &&
      this.signupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupIdIsSet = true;
      cloned.signupId = this.signupId?.removeUnset(filter);
    } else {
      //cloned.signupIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassAttendanceFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.attendApplyFilter(filter)) this.attendIsSet = false;

    if (!this.sessionIdApplyFilter(filter)) this.sessionIdIsSet = false;
    this.sessionId?.unassignAll(filter);

    if (!this.signupIdApplyFilter(filter)) this.signupIdIsSet = false;
    this.signupId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassAttendanceFullMeta.assignId,
      UnifiedClassAttendanceFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  attendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassAttendanceFullMeta.attend,
      UnifiedClassAttendanceFullMeta,
      this.attend,
      this,
    );
  }
  attendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendIsSet && this.attendApplyFilter(filter)) return true;

    return false;
  }
  sessionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassAttendanceFullMeta.sessionId,
      UnifiedClassAttendanceFullMeta,
      this.sessionId,
      this,
    );
  }
  sessionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionIdIsSet && this.sessionIdApplyFilter(filter)) return true;
    return this.sessionId?.anySet(filter) == true;

    return false;
  }
  signupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassAttendanceFullMeta.signupId,
      UnifiedClassAttendanceFullMeta,
      this.signupId,
      this,
    );
  }
  signupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupIdIsSet && this.signupIdApplyFilter(filter)) return true;
    return this.signupId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.attendIsSetDeep(filter)) return true;
    if (this.sessionIdIsSetDeep(filter)) return true;
    if (this.signupIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
